import { Observable } from './observable';
import { ObserverLike, PartialObserver, lift } from './observer';
import { Subscription } from './subscription';

export class Subject<T> {
  private observers: Set<PartialObserver<T>> = new Set();

  subscribe(observer: ObserverLike<T>): Subscription {
    const observerObject = lift(observer);
    this.observers.add(observerObject);

    const subscription = new Subscription();
    subscription.add(() => {
      this.observers.delete(observerObject);
    });

    return subscription;
  }

  next(value: T): void {
    this.observers.forEach((observer) => observer.next?.(value));
  }

  complete(): void {
    this.observers.forEach((observer) => observer.complete?.());
    this.observers.clear();
  }

  error(err: unknown): void {
    this.observers.forEach((observer) => observer.error?.(err));
    this.observers.clear();
  }

  asObservable(): Observable<T> {
    return new Observable((observer) => this.subscribe(observer));
  }

  dispose(): void {
    this.observers.clear();
  }
}
